<app-group-box pageTitle="{{ 'page.DumpsterDetail.Section.Timeline.Title' | translate }}">
  <div class="box-standard-padding events-data">
    <app-custom-grid
      [defaultSort]="eventsDefaultSort"
      [columns]="eventsColumns"
      [pageable]="true"
      [pageSizes]="true"
      [filterable]="true"
      [items]="events"
    ></app-custom-grid>
  </div>
</app-group-box>

<ng-template windowVisualizer></ng-template>
